// SimpleBar wird in project.js als globale Klasse verwendet (new SimpleBar(...))
import SimpleBar from '../../js/src/simplebar';

(window as any).SimpleBar = SimpleBar;
